import React from 'react';
import CampaignStatsChart from './CampaignStatsChart';
import { PeopleFill, GiftFill, GeoAltFill } from 'react-bootstrap-icons';
import TreasureMap from './TreasureMap';

const BasketballReport = ({ basketBallEvents, totalSignups }) => {
  if (!basketBallEvents || basketBallEvents.length === 0) {
    return <p>표시할 농구 이벤트가 없습니다.</p>;
  }

  return (
    <div>
      {basketBallEvents.map(event => (
        <div key={event.eventKey} className="card mb-4 shadow-sm">
          <div className="card-header bg-info text-white">
            <h3 className="mb-0">{event.eventName} ({event.statusName})</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-5">
                <h4 className="mb-3"><PeopleFill className="me-2" />참여 현황</h4>
                <CampaignStatsChart
                  signupCount={totalSignups}
                  participantCount={event.participantCount}
                  todaySignups={event.todaySignups}
                />
                {/* Event Summary - MOVED HERE */}
                <div className="card mb-3">
                  <div className="card-header">
                    <h5 className="mb-0">이벤트 요약</h5>
                  </div>
                  <div className="card-body">
                    <p className="card-text">
                      <PeopleFill className="me-2" />
                      <strong>참가자:</strong> {event.participantCount} 명
                    </p>
                    <p className="card-text">
                      <PeopleFill className="me-2" />
                      <strong>오늘 가입자:</strong> {event.todaySignups} 명
                    </p>
                    <p className="card-text">
                      <PeopleFill className="me-2" />
                      <strong>브랜드 노출 횟수:</strong> {event.brandExposure} 회
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                {/* Goals Information (Map) - MOVED HERE */}
                {event.goals?.length > 0 ? (
                  <div className="card mb-3">
                    <div className="card-header">
                      <h5 className="mb-0"><GeoAltFill className="me-2" />골대 지도</h5>
                    </div>
                    <div className="card-body">
                      <div style={{border: '1px solid #ddd', borderRadius: '0.25rem', height: '300px'}}>
                        <TreasureMap
                          markers={event.goals.map((goal, index) => ({
                            boxKey: `${event.eventKey}-${index}`,
                            latitude: goal.latitude,
                            longitude: goal.longitude,
                            goalname: goal.goalname,
                            hitscore: goal.hitscore,
                          }))}
                        />
                      </div>
                      {/* Display distance here if clarified by user */}
                      <table className="table table-bordered table-striped mt-3">
                        <thead className="table-dark">
                          <tr>
                            <th>골대명</th>
                            <th>위도</th>
                            <th>경도</th>
                            <th>거리</th>
                            <th>보물상자 확률</th>
                            <th>꽝 확률</th>
                          </tr>
                        </thead>
                        <tbody>
                          {event.goals.map((goal, index) => (
                            <tr key={`${event.eventKey}-${index}`}>
                              <td>{goal.goalname}</td>
                              <td>{goal.latitude}</td>
                              <td>{goal.longitude}</td>
                              <td>{goal.distance}m</td>
                              <td>{(goal.bonusrate * 100).toFixed(0)}%</td>
                              <td>{(goal.loserate * 100).toFixed(0)}%</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-info">표시할 골대가 없습니다.</div>
                )}

                <h4 className="mt-4"><GiftFill className="me-2" />상품 목록</h4>
                {event.items?.length > 0 ? (
                  <table className="table table-striped table-bordered table-hover mt-2">
                    <thead className="table-dark">
                      <tr>
                        <th>상품명</th>
                        <th>수량</th>
                      </tr>
                    </thead>
                    <tbody>
                      {event.items.map(item => (
                        <tr key={item.itemkey}>
                          <td>{item.itemname}</td>
                          <td>{item.itemcount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="alert alert-info mt-2">표시할 상품이 없습니다.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BasketballReport;
